import React, { useEffect, useRef, useState } from 'react';
import { Link } from "react-router-dom";
import { Button, Badge } from "react-bootstrap";
import { Tooltip, OverlayTrigger } from "react-bootstrap";
import swal from "sweetalert2";
import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-dt/css/dataTables.dataTables.css';
import break_box from '../../../../images/product/products.png';
import lunch_box from '../../../../images/product/meals_box.png';
import dinner_box from '../../../../images/product/dinner_box.png';
import meals_box from '../../../../images/product/meals_box.png';
import LightGallery from 'lightgallery/react';
import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-zoom.css';
import 'lightgallery/css/lg-thumbnail.css';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom';
// import AddProduct from './../../../modal/Package_Management/Manage_Product/AddProduct';
import AddProducts from './../../../modal/Package_Management/Manage_Product/AddProducts';
import EditProduct from './../../../modal/Package_Management/Manage_Product/EditProduct';
import ViewProduct from './../../../modal/Package_Management/Manage_Product/ViewProduct';
import AddItemQuantity from './../../../modal/Package_Management/Manage_Product/AddItemQuantity';
import { Row, Col, Tab, Nav, Dropdown } from "react-bootstrap";
// import AddProdCat from './../../../modal/Package_Management/Manage_Product/AddProdCat';
// import EditProdCat from './../../../modal/Package_Management/Manage_Product/EditProdcat';
import axios from 'axios'; // new
import { toast } from 'react-toastify';

import AddItemcategories from './../../../modal/Package_Management/Manage_Product/AddItemCategories';
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const Products = () => {
    const baseURL = process.env.REACT_APP_API_BASE_URL;
    const branch_id = parseInt(localStorage.getItem("branch_id"), 10);
    const [product, setProduct] = useState([]); // used for product list
    const [hasFetched, setHasFetched] = useState(false);
    const [manageProductCount, setManageProductCount] = useState(0);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [searchTerm, setSearchTerm] = useState('');
    const [searchTimeout, setSearchTimeout] = useState(null);
    const [perPage, setPerPage] = useState(25);
    const [TotalCount, setTotalCount] = useState('');

    const fetchData = (query = searchTerm, currentPage = page) => {

        // ✅ Prepare query parameters
        const params = {
            page: currentPage,
            per_page: perPage,
            search: query,
            branch_id
        };

        axios
            .get(`${baseURL}/manage-products`, { params })
            .then((response) => {
                const data = response.data;
                const newData = data.data?.data || [];

                setProduct(newData);
                setManageProductCount(data.ManageProductCount || 0);
                setTotalPages(data.data?.last_page || 1);
                setTotalCount(data.data?.total || 0);
                setHasFetched(true);
            })
            .catch((error) => {
                console.error("❌ Error fetching data:", error);
                setProduct([]);
                setHasFetched(true);
            });
    };

    useEffect(() => {
        if (searchTimeout) clearTimeout(searchTimeout);

        const timeout = setTimeout(() => {
            setPage(1); // Reset page
            fetchData(searchTerm, 1);
        }, 400); // delay in ms

        setSearchTimeout(timeout);

        return () => clearTimeout(timeout); // cleanup on unmount or before next effect
    }, [searchTerm]);

    useEffect(() => {
        if (branch_id) {
            fetchData(searchTerm, page);
        }
    }, [page, perPage, branch_id]); // only trigger on page/perPage changes

    useEffect(() => {
        if (hasFetched && product.length > 0) {
            if (tableRef.current) {
                if (!$.fn.dataTable.isDataTable(tableRef.current)) {
                    $(tableRef.current).DataTable({
                        "destroy": true,
                        "paging": false,
                        "searching": false,
                        "info": false,
                        "responsive": true,
                        pageLength: 25,
                        //   "aaSorting": [],
                        "ordering": false,
                        "language": {
                            "lengthMenu": "Show&nbsp;&nbsp; _MENU_",
                        },
                        "dom":
                            "<'row'" +
                            "<'col-sm-6 d-flex align-items-center justify-content-start mb-2'l>" +
                            "<'col-sm-6 d-flex align-items-center justify-content-end mb-2'f>" +
                            ">" +
                            "<'table-responsive'tr>" +
                            "<'row'" +
                            "<'col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start mt-2'i>" +
                            "<'col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end mt-2'p>" +
                            ">"
                    });
                }
            }
        }
    }, [hasFetched, product]);

    const onInit = () => { };
    const [key, setKey] = useState('products');
    const tableRef = useRef(null);
    const [open, setOpen] = useState(false);
    const [modalType, setModalType] = useState("");

    const [isModalOpen, setIsModalOpen] = useState(false); // used for view
    const [selectedProductId, setSelectedProductId] = useState(null); // used for view
    const [selectedProduct, setSelectedProduct] = useState(null);  // used for view

    const handleModalToggleView = () => {
        setModalType("ViewProduct");
        setOpen(true);
    };

    const handleModalToggleAdd = () => {
        setModalType("AddProduct");
        setOpen(true);
    };

    const handleModalToggleAdds = () => {
        setModalType("AddProducts");
        setOpen(true);
    };

    // used for view
    const handleModalToggleProductView = (productId) => {
        setSelectedProductId(productId);
        fetchProductById(productId); // Fetch the product details
        setIsModalOpen(true); // Open the modal
    };
    // used for view
    const handleModalClose = () => {
        setIsModalOpen(false);
        setSelectedProductId(null); // Reset product ID
        setSelectedProduct(null); // Clear product data when modal closes
    };

    // changed duplicate view url 
    const fetchProductById = (id) => {
        axios.get(`${baseURL}/manages-products/${id}`)
            .then(response => {
                const productData = response.data?.data;
                if (productData) {
                    setSelectedProduct(productData);
                } else {
                    console.warn("Product data not found in response");
                }
            })
            .catch(error => {
                console.error("Error fetching product details:", error);
            });
    };

    // edit start
    const [showEditModal, setShowEditModal] = useState(false);  // Controls modal visibility
    const [productIdToEdit, setProductIdToEdit] = useState(null);
    const [productData, setProductData] = useState({});
    const handleModalToggleEdit = (productId) => {
        setProductIdToEdit(productId);  // Set the product ID to edit 
        setShowEditModal(true);         // Show the modal
    };

    // add categories
    const [showCategoriesModal, setShowCategoriesModal] = useState(false);
    const handleModalToggleCategories = (productId) => {
        setProductIdToEdit(productId);  // Set the product ID to edit 
        setShowCategoriesModal(true);         // Show the modal
    };

    // Function to close the modal
    const handleCloseModal = () => {
        setShowEditModal(false);
        setShowCategoriesModal(false);
        setProductIdToEdit(null);  // Reset product ID when modal is closed
    };

    useEffect(() => {
        if (productIdToEdit) {
            // Fetch the product data based on the productId (sno) when the modal is shown
            const fetchProductData = async () => {
                try {
                    // setLoading(true);
                    const response = await axios.get(`${baseURL}/manages-products/${productIdToEdit}`);
                    if (response.data) {
                        setProductData(response.data.data);
                    }
                } catch (error) {
                    console.error("Error fetching product data:", error);
                } finally {
                    // setLoading(false);
                }
            };
            fetchProductData();
        }
    }, [productIdToEdit]);


    // item quantity start
    const [selectedProductItem, setSelectedProductItem] = useState(null);
    const [isItemQuantityModalOpen, setIsItemQuantityModalOpen] = useState(false);
    const [isViewProductModalOpen, setIsViewProductModalOpen] = useState(false);

    const handleModalToggleItemQty = (id) => {
        setSelectedProductItem(null);  // Reset selected item data
        fetchProductDetails(id);  // Fetch the details for the selected item
        setIsItemQuantityModalOpen(true);  // Open AddItemQuantity Modal
        setIsViewProductModalOpen(false);  // Ensure ViewProduct Modal is closed
    };

    const fetchProductDetails = async (id) => {
        try {
            const response = await axios.get(`${baseURL}/manage-products/${id}/item-quantity`);
            const data = response.data;
            console.log('Fetched product data:', data); // Log the fetched data to verify if the ID is present
            setSelectedProductItem(data); // Set fetched data
        } catch (error) {
            console.error("Error fetching product details:", error);
        }
    };
    // item quantity end

    const [categoryCount, setCategoryCount] = useState(0); // used for product category count

    // product status
    useEffect(() => {
        const branch_id = parseInt(localStorage.getItem("branch_id"), 10);

        // Validate branch_id before making the request
        if (!branch_id || isNaN(branch_id)) {
            console.warn("No valid branch_id found in localStorage.");
            setCategoryCount(0);
            return;
        }

        const fetchCategories = async () => {
            try {
                const response = await axios.get(`${baseURL}/product-categories`, {
                    params: { branch_id } // ✅ Send branch_id as query parameter
                });

                const data = response.data;

                if (Array.isArray(data)) {
                    setCategoryCount(data.length);
                } else if (Array.isArray(data?.data)) {
                    setCategoryCount(data.data.length);
                } else {
                    console.warn("Unexpected response format for categories:", data);
                    setCategoryCount(0);
                }
            } catch (error) {
                console.error("Error fetching product categories:", error);
                setCategoryCount(0);
            }
        };

        fetchCategories();
    }, [baseURL]); // Re-run if baseURL changes

    const handleProductStatusChange = (productId, currentStatus) => {
        const newStatus = currentStatus === 0 ? 1 : 0;

        axios.put(`${baseURL}/manage-products/status/${productId}`, { status: newStatus })
            .then(() => {
                // Re-fetch products after status update
                fetchData();
            })
            .catch(error => {
                console.error("Error updating product status:", error);
            });
    };

    const DeleteModal = (productId, productName, onDeleted) => { // change 
        swal.fire({
            html: `
                    <div class="alert alert-danger px-2 py-2" role="alert">
                        <strong>OOPS! </strong> You're about to lose one Products
                        <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                    </div>
                    <p class="text-center"><b>${productName}</b></p>  
                    <div class="text-center">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="48" height="48">
                            <defs>
                                <radialGradient id="radial-gradient" cx="-27.957" cy="8.563" r="6" gradientTransform="matrix(3 0 0 2.5 107.871 -4.408)" gradientUnits="userSpaceOnUse">
                                    <stop offset="0" stop-color="#5987dd"/>
                                    <stop offset=".118" stop-color="#638bd6"/>
                                    <stop offset=".316" stop-color="#7d98c3"/>
                                    <stop offset=".572" stop-color="#a8aba3"/>
                                    <stop offset=".871" stop-color="#e3c678"/>
                                    <stop offset="1" stop-color="#ffd364"/>
                                </radialGradient>
                                <style>.cls-3{fill:#ffb32b}.cls-4{fill:#273941}.cls-5{fill:#141e21}.cls-6{fill:#f6fafd}</style>
                            </defs>
                            <g id="_27-feel_bad" data-name="27-feel bad">
                                <circle cx="24" cy="24" r="23" style="fill:#ffce52"/>
                                <ellipse cx="24" cy="17" rx="18" ry="15" style="fill:url(#radial-gradient)"/>
                                <path class="cls-3" d="M46 23c0 10.493-9.85 19-22 19S2 33.493 2 23h-.975c-.014.332-.025.665-.025 1a23 23 0 0 0 46 0c0-.335-.011-.668-.025-1z"/>
                                <ellipse class="cls-4" cx="33" cy="23" rx="3" ry="4"/>
                                <ellipse class="cls-5" cx="33" cy="23" rx="2" ry="3"/>
                                <circle class="cls-6" cx="34" cy="22" r="1"/>
                                <ellipse class="cls-4" cx="15" cy="23" rx="3" ry="4"/>
                                <ellipse class="cls-5" cx="15" cy="23" rx="2" ry="3"/>
                                <circle class="cls-6" cx="16" cy="22" r="1"/>
                                <path class="cls-5" d="M10 19v-2c3.722 0 6-1.295 6-2h2c0 2.626-4.024 4-8 4zM38 19c-3.976 0-8-1.374-8-4h2c0 .705 2.278 2 6 2z"/>
                                <path class="cls-4" d="M24 35h-5.5a5.265 5.265 0 0 1 5.5-5 5.265 5.265 0 0 1 5.5 5z"/>
                                <path class="cls-5" d="M24 31a5.4 5.4 0 0 1 5.39 4h.11a5.265 5.265 0 0 0-5.5-5 5.265 5.265 0 0 0-5.5 5h.11A5.4 5.4 0 0 1 24 31z"/>
                                <path d="M47 12a4 4 0 0 1-8 0c0-2.209 3-8 4-8s4 5.791 4 8z" style="fill:#3bc5f6"/>
                                <path d="M43 4c-1 0-4 5.791-4 8a4 4 0 0 0 8 0c0-2.209-3-8-4-8zm0 8.5a2.848 2.848 0 0 1-3-2.667C40 8.361 42.25 4.5 43 4.5s3 3.861 3 5.333a2.848 2.848 0 0 1-3 2.667z" style="fill:#00a3e1"/>
                                <path class="cls-3" d="M43 16a3.991 3.991 0 0 1-3.861-3.008A4.661 4.661 0 0 0 39 14a4 4 0 0 0 6.846 2.807q-.255-.777-.562-1.529A3.982 3.982 0 0 1 43 16z"/>
                                <ellipse class="cls-6" cx="44" cy="11" rx=".825" ry="1.148" transform="rotate(-45.02 44 11)"/>
                                <ellipse class="cls-6" cx="44.746" cy="9.5" rx=".413" ry=".574" transform="rotate(-45.02 44.746 9.5)"/>
                                <ellipse class="cls-6" cx="36" cy="9" rx=".825" ry="1.148" transform="rotate(-45.02 36 9)"/>
                                <ellipse class="cls-6" cx="29.746" cy="4.5" rx=".413" ry=".574" transform="rotate(-45.02 29.746 4.5)"/>
                                <ellipse class="cls-6" cx="33" cy="7" rx="1.65" ry="2.297" transform="rotate(-45.02 33 7)"/>
                            </g>
                        </svg>
                    </div>
                `,
            showCancelButton: true,
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'No, Cancel',
            reverseButtons: true,
            customClass: {
                title: 'fs-6',
                cancelButton: 'btn btn-sm btn-secondary',
                confirmButton: 'btn btn-sm btn-danger',
                htmlContainer: 'text-left'
            },
            allowOutsideClick: false,
            allowEscapeKey: false,
        }).then((result) => {

            if (result.isConfirmed) {
                axios.delete(`${baseURL}/manage-products/${productId}`)
                    .then(() => {
                        toast.success(`Product "${productName}" deleted successfully!`);
                        if (onDeleted) onDeleted();
                    })
                    .catch(error => {
                        console.error("Deletion failed:", error);
                        toast.error(`Failed to delete "${productName}"`);
                    });
            } else {
                toast.info(`Delete process cancelled for "${productName}"`);
            }
        });
    };

    const [isMaintenance, setIsMaintenance] = useState(false);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let isMounted = true;

        const checkMaintenanceStatus = async () => {
            try {
                const response = await axios.get(`${baseURL}/maintenance-mode?branch_id=${branch_id}`);
                const data = response.data.data || [];
                const branchStatus = data.find((item) => item.slug === "manage-products"); // use managebranch slug

                if (isMounted) {
                    setIsMaintenance(branchStatus?.maintenancemode_status === 1);
                }
            } catch (error) {
                console.error("Error checking maintenance mode:", error);
                if (isMounted) setIsMaintenance(false);
            } finally {
                if (isMounted) setLoading(false);
            }
        };

        checkMaintenanceStatus();

        return () => {
            isMounted = false;
        };
    }, [baseURL, branch_id]);

    if (isMaintenance) {
        return (
            <div
                className="d-flex flex-column align-items-center justify-content-center text-center"
                style={{ height: "100vh", width: "100vw" }}
            >
                <h1 className="text-warning mb-3">🚧 Under Maintenance</h1>
                <p className="text-muted fs-5">
                    The <strong>Manage Product </strong> module is currently under maintenance. <br />
                    Please check back later.
                </p>
            </div>
        );
    }

    return (
        <>
            {loading ? (
                <div className="d-flex align-items-center justify-content-between flex-wrap page-titles px-0 py-1 mx-0">
                    <div className='mb-2'>
                        <div className="mb-0 px-0">
                            <h4 style={{ color: '#025d3a' }}><Skeleton width={150} /></h4>
                        </div>
                        <ol className="breadcrumb fs-7">
                            <li className="breadcrumb-item"><Skeleton width={70} /></li>
                            <li className="breadcrumb-item"><Skeleton width={20} /></li>
                            <li className="breadcrumb-item active"><Skeleton width={100} /></li>
                        </ol>
                    </div>
                </div>
            ) : (
                <div className="d-flex align-items-center justify-content-between page-titles px-0 py-1 mx-0 flex-wrap">
                    <div className='mb-2'>
                        <div className="mb-0 px-0">
                            <h4 style={{ color: '#025d3a' }}>Manage Products</h4>
                        </div>
                        <ol className="breadcrumb fs-7">
                            <li className="breadcrumb-item"><Link to='/dashboard'>Dashboard</Link></li>
                            <li className="breadcrumb-item"><i class="fa-solid fa-angles-right fs-8"></i></li>
                            <li className="breadcrumb-item active">Package Management</li>
                        </ol>
                    </div>

                    {open && modalType === "ViewProduct" && (
                        <ViewProduct show={open} onClose={() => setOpen(false)} />
                    )}
                    {/* {open && modalType === "AddProduct" && (
                        <AddProduct show={open} onClose={() => setOpen(false)} onSuccess={() => {
                            fetchData();
                        }} />
                    )} */}

                    {open && modalType === "AddProducts" && (
                        <AddProducts show={open} onClose={() => setOpen(false)} onSuccess={() => {
                            fetchData();
                        }} />
                    )}

                    {open && modalType === "EditProduct" && (
                        <EditProduct show={open} onClose={() => setOpen(false)} productId={productIdToEdit} refresh={fetchData}
                        />
                    )}

                    {open && modalType === "AddItemQuantity" && (
                        <AddItemQuantity show={open} onClose={() => setOpen(false)} />
                    )}
                </div>
            )}

            {loading ? (
                <Col xl={12} className='mb-3'>
                    <div className="custom-tab-1">
                        <Nav as="ul" className="nav-tabs">
                            {[1, 2].map((_, index) => (
                                <Nav.Item as="li" key={index}>
                                    <Nav.Link disabled className="d-flex align-items-center">
                                        {/* Icon */}
                                        <Skeleton circle width={20} height={20} />

                                        {/* Label */}
                                        <div className="ms-2">
                                            <Skeleton width={80} height={14} />
                                        </div>

                                        {/* Badge */}
                                        <div className="ms-2">
                                            <Skeleton width={30} height={18} borderRadius={12} />
                                        </div>
                                    </Nav.Link>
                                </Nav.Item>
                            ))}
                        </Nav>
                        <Row>
                            <Col xl={12} className='mb-3 d-flex align-items-end justify-content-end gap-3'>
                                <div className="d-flex align-items-end justify-content-end">
                                    <div className="d-flex align-items-center gap-3 flex-wrap mb-2">
                                        {[1].map((_, index) => (
                                            <Skeleton
                                                key={index}
                                                width={110}
                                                height={34}
                                                borderRadius={6}
                                            />
                                        ))}
                                    </div>
                                </div>
                            </Col>
                            <Col xl={12}>
                                <div className="table-container">
                                    <div className="d-flex justify-content-between align-items-center mb-3">
                                        {/* Left: Show entries dropdown */}
                                        <div>
                                            <label className="me-2"><Skeleton width={50} height={25} /></label>
                                            <Skeleton width={50} height={25} className="mb-1" />
                                        </div>

                                        {/* Right: Search input */}
                                        <div>
                                            <Skeleton width={150} height={25} className="mb-1" />
                                        </div>
                                    </div>

                                    <table style={{ borderBottom: '2px solid #ddd' }} id="kt_datatable_responsive_approved" className="table align-middle table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable">
                                        <thead>
                                            <tr>
                                                <th><Skeleton width={100} height={16} /></th>
                                                <th><Skeleton width={100} height={16} /></th>
                                                <th><Skeleton width={100} height={16} /></th>
                                                <th><Skeleton width={100} height={16} /></th>
                                                <th><Skeleton width={100} height={16} /></th>
                                                <th><Skeleton width={100} height={16} /></th>
                                            </tr>
                                        </thead>
                                        <tbody className="text-gray-600 fw-semibold fs-7">
                                            {[...Array(perPage)].map((_, i) => (
                                                <tr key={i}>
                                                    <td><Skeleton /></td>
                                                    <td><Skeleton /></td>
                                                    <td><Skeleton /></td>
                                                    <td><Skeleton /></td>
                                                    <td><Skeleton /></td>
                                                    <td><Skeleton /></td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>

                                    <div className="d-flex justify-content-between align-items-center mt-3">
                                        {/* Bottom left: Showing x to y of z entries */}
                                        <div>
                                            <Skeleton width={180} height={15} />
                                        </div>

                                        {/* Bottom right: Pagination */}
                                        <nav>
                                            <div className="d-flex gap-2">
                                                {[...Array(4)].map((_, i) => (
                                                    <Skeleton key={i} width={40} height={25} borderRadius={5} />
                                                ))}
                                            </div>
                                        </nav>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </Col >
            ) : (
                <Col xl={12} className='mb-3'>
                    <div className="custom-tab-1">
                        <Tab.Container activeKey={key} onSelect={(k) => setKey(k)}>
                            <Nav as="ul" className="nav-tabs">
                                <Nav.Item as="li" >
                                    <Nav.Link eventKey="products">
                                        <i className="fa fa-shopping-basket me-3" />
                                        <label className="fs-6">
                                            Products
                                        </label>
                                        <Badge as="a" href="" bg=" badge-circle" className='badge-outline-info ms-2 fw-bold fs-8'>
                                            {String(manageProductCount).padStart(2, '0')}
                                        </Badge>
                                    </Nav.Link>
                                </Nav.Item>
                                <Nav.Item as="li">
                                    <Nav.Link >
                                        <Link to="/product-category" className="d-flex align-items-center text-decoration-none">
                                            <i className="fa-solid fa-list me-3" />
                                            <label className="fs-6">
                                                Product Category
                                            </label>
                                            <Badge as="a" href="" bg=" badge-circle" className="badge-outline-info ms-2 fw-bold fs-8">
                                                {String(categoryCount).padStart(2, '0')}
                                            </Badge>
                                        </Link>
                                    </Nav.Link>
                                </Nav.Item>
                            </Nav>
                            <Tab.Content className="pt-4">
                                <Tab.Pane eventKey="products">
                                    <Row>
                                        <Col xl={12} className='mb-3 d-flex align-items-end justify-content-end gap-3'>

                                            <Link to={"#"} onClick={handleModalToggleAdds} className="btn btn-primary float-end btn-sm mb-2">
                                                <span className='me-2'><i class="fa-solid fa-plus fs-8"></i></span>
                                                <span className=''>Add Products</span>
                                            </Link>
                                        </Col>
                                        <Col xl={12}>
                                            <div className="table-container">
                                                <div className="d-flex justify-content-between align-items-center mb-3">
                                                    {/* Left: Show entries dropdown */}
                                                    <div>
                                                        <label className="me-2">Show</label>
                                                        <select
                                                            className="form-select d-inline w-auto"
                                                            style={{ fontSize: '0.85rem', height: '30px' }}
                                                            value={perPage}
                                                            onChange={(e) => {
                                                                setPerPage(Number(e.target.value));
                                                                setPage(1); // Reset to first page
                                                            }}
                                                        >
                                                            <option value={10}>10</option>
                                                            <option value={25}>25</option>
                                                            <option value={50}>50</option>
                                                            <option value={100}>100</option>
                                                        </select>
                                                    </div>


                                                    <div>
                                                        <input
                                                            type="text"
                                                            style={{ fontSize: '0.85rem', height: '40px' }}
                                                            placeholder="Search by name or category..."
                                                            className="form-control"
                                                            value={searchTerm}
                                                            onChange={(e) => {
                                                                const onlyLetters = e.target.value.replace(/[^a-zA-Z\s]/g, '');
                                                                setSearchTerm(onlyLetters);
                                                            }}
                                                        />

                                                    </div>
                                                </div>
                                                <table className="product_data_table table align-middle table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable" style={{ borderBottom: '2px solid #ddd', overflowX: 'scroll' }}>
                                                    <thead>
                                                        <tr className=" text-start text-muted fw-bold fs-6 gs-0 th_head">
                                                            <th className='min-w-100px'>Products</th>
                                                            <th className='min-w-90px'>Category</th>
                                                            <th className='min-w-100px'><OverlayTrigger
                                                                trigger={['hover', 'focus']}
                                                                placement="bottom"
                                                                overlay={
                                                                    <Tooltip className="toltip-popover">
                                                                        <span className="fs-8 text-white fw-semibold">Production Start Time / End Time</span>
                                                                    </Tooltip>
                                                                }
                                                            >
                                                                <label className="">Production ST / ET</label>
                                                            </OverlayTrigger></th>

                                                            <th className='min-w-100px'><OverlayTrigger
                                                                trigger={['hover', 'focus']}
                                                                placement="bottom"
                                                                overlay={
                                                                    <Tooltip className="toltip-popover">
                                                                        <span className="fs-8 text-white fw-semibold">Packing Start Time / End Time</span>
                                                                    </Tooltip>
                                                                }
                                                            >
                                                                <label className="">Packing ST / ET</label>
                                                            </OverlayTrigger></th>

                                                            <th className='min-w-100px'><OverlayTrigger
                                                                trigger={['hover', 'focus']}
                                                                placement="bottom"
                                                                overlay={
                                                                    <Tooltip className="toltip-popover">
                                                                        <span className="fs-8 text-white fw-semibold">Delivery Start Time / End Time</span>
                                                                    </Tooltip>
                                                                }
                                                            >
                                                                <label className="">Delivery ST / ET</label>
                                                            </OverlayTrigger></th>
                                                            <th className='min-w-125px text-center'>Item Count</th>
                                                            <th className='min-w-100px'>Status</th>
                                                            <th className='min-w-80px'>Actions</th>
                                                        </tr>
                                                    </thead>


                                                    <tbody className="text-gray-600 fw-semibold fs-7">
                                                        {product.length === 0 ? (
                                                            <tr>
                                                                <td colSpan="8" className="text-center text-muted py-4">
                                                                    No products found.
                                                                </td>
                                                            </tr>
                                                        ) : (
                                                            product.map((item, index) => (
                                                                <tr key={item.sno}>
                                                                    <td>
                                                                        <div className="d-flex align-items-center justify-content-start gap-2">
                                                                            <LightGallery
                                                                                onInit={onInit}
                                                                                speed={500}
                                                                                plugins={[lgThumbnail, lgZoom]}
                                                                            >
                                                                                <div data-src={item.product_image || break_box} className='border rounded px-1 py-0'>
                                                                                    <img src={item.product_image || break_box} alt="Break Box" className='cursor-pointer w-45px h-45px' />
                                                                                </div>
                                                                            </LightGallery>
                                                                            <div>
                                                                                <label className='text-black font-w400 fs-7'>{item.product_name}</label>
                                                                            </div>
                                                                        </div>
                                                                    </td>
                                                                    <td>
                                                                        <OverlayTrigger
                                                                            trigger={['hover', 'focus']}
                                                                            placement="bottom"
                                                                            overlay={
                                                                                <Tooltip className="toltip-popover">
                                                                                    <span className="fs-8 text-white fw-semibold">
                                                                                        {item.product_category_name}
                                                                                    </span>
                                                                                </Tooltip>
                                                                            }
                                                                        >
                                                                            <div className="text-truncate mw-250px text-black font-w400 fs-7">
                                                                                {item.product_category_name}
                                                                            </div>
                                                                        </OverlayTrigger>
                                                                    </td>
                                                                    <td>
                                                                        <label className='text-green font-w500 fs-7'>{item.production_start_time}</label>
                                                                        <div className="d-block">
                                                                            <label className="fs-7 text-danger font-w500">{item.production_end_time}</label>
                                                                        </div>
                                                                    </td>
                                                                    <td>
                                                                        <label className='text-green font-w500 fs-7'>{item.packing_start_time}</label>
                                                                        <div className="d-block">
                                                                            <label className="fs-7 text-danger font-w500">{item.packing_end_time}</label>
                                                                        </div>
                                                                    </td>
                                                                    <td>
                                                                        <label className='text-green font-w500 fs-7'>{item.delivery_start_time}</label>
                                                                        <div className="d-block">
                                                                            <label className="fs-7 text-danger font-w500">{item.delivery_end_time}</label>
                                                                        </div>
                                                                    </td>
                                                                    <td className='text-center'>
                                                                        <Badge bg="warning" className='text-white fs-7 rounded-pill'>{item.total_item_count}</Badge>
                                                                    </td>
                                                                    <td>
                                                                        <div className="form-check form-switch d-flex align-items-center mb-3">
                                                                            <input
                                                                                className="form-check-input me-2"
                                                                                type="checkbox"
                                                                                role="switch"
                                                                                checked={item.status == 0}
                                                                                onChange={() => handleProductStatusChange(item.sno, item.status)}
                                                                            />
                                                                        </div>
                                                                    </td>
                                                                    <td>
                                                                        <span className="text-end">

                                                                            <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover'><span className='fs-8 text-white fw-semibold'>Item Categories</span></Tooltip>} >
                                                                                <Button variant="primary tp-btn-light px-2 py-1 me-1"
                                                                                    onClick={() => handleModalToggleCategories(item.sno)}>
                                                                                    <span><i className="fa-solid fa-file-circle-plus fs-6 mt-1"></i></span>
                                                                                </Button>
                                                                            </OverlayTrigger>

                                                                            <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover'><span className='fs-8 text-white fw-semibold'>View</span></Tooltip>} >
                                                                                <Button variant="primary tp-btn-light px-2 py-1 me-1"
                                                                                    onClick={() => handleModalToggleProductView(item.sno)}>
                                                                                    <span><i className="fa-solid fa-eye fs-6 mt-1"></i></span>
                                                                                </Button>
                                                                            </OverlayTrigger>

                                                                            <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover'><span className='fs-8 text-white fw-semibold'>Edit</span></Tooltip>} >
                                                                                <Link to={"#"} onClick={() => handleModalToggleEdit(item.sno)}>
                                                                                    <Button variant="primary tp-btn-light px-2 py-1 me-1">
                                                                                        <span><i className="fa-solid fa-pen-to-square fs-6 mt-1"></i></span>
                                                                                    </Button>
                                                                                </Link>
                                                                            </OverlayTrigger>
                                                                        </span>
                                                                    </td>
                                                                </tr>
                                                            ))
                                                        )}
                                                    </tbody>

                                                </table>
                                                <div className="d-flex justify-content-between align-items-center mt-3">
                                                    {/* Bottom left: Showing x to y of z entries */}
                                                    <div>
                                                        {product.length > 0 ? (
                                                            <span className="text-muted">
                                                                Showing {(page - 1) * perPage + 1} to {(page - 1) * perPage + product.length} of {TotalCount} entries
                                                            </span>
                                                        ) : (
                                                            <span className="text-muted">
                                                                Showing 0 to 0 of 0 entries
                                                            </span>
                                                        )}
                                                    </div>

                                                    {/* Bottom right: Pagination */}
                                                    <nav>
                                                        <ul className="pagination mb-0" style={{ fontSize: '0.75rem' }}>
                                                            <li className={`page-item ${page === 1 ? 'disabled' : ''}`}>
                                                                <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(page - 1)}>Previous</button>
                                                            </li>
                                                            {[...Array(totalPages)].map((_, i) => (
                                                                <li key={i} className={`page-item ${page === i + 1 ? 'active' : ''}`}>
                                                                    <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(i + 1)}>{i + 1}</button>
                                                                </li>
                                                            ))}
                                                            <li className={`page-item ${page === totalPages ? 'disabled' : ''}`}>
                                                                <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(page + 1)}>Next</button>
                                                            </li>
                                                        </ul>
                                                    </nav>

                                                </div>

                                                <AddItemQuantity
                                                    show={isItemQuantityModalOpen}
                                                    onClose={() => setIsItemQuantityModalOpen(false)}
                                                    productData={selectedProductItem}
                                                    id={selectedProductItem?.product_id}
                                                />

                                                <EditProduct
                                                    show={showEditModal}
                                                    onClose={handleCloseModal}
                                                    productId={productIdToEdit}
                                                    productData={productData}
                                                    refresh={fetchData}
                                                />

                                                <AddItemcategories
                                                    show={showCategoriesModal}
                                                    onClose={handleCloseModal}
                                                    productId={productIdToEdit}
                                                    productData={productData}
                                                    refresh={fetchData}
                                                />

                                                <ViewProduct
                                                    show={isModalOpen}
                                                    onClose={handleModalClose}
                                                    product={selectedProduct} // Pass the fetched product data to the modal
                                                />
                                            </div>
                                        </Col>
                                    </Row>
                                </Tab.Pane>
                            </Tab.Content>
                        </Tab.Container>
                    </div>
                </Col>
            )}
        </>
    )


}
export default Products;